import { Button, Div, H2, Span, reactive, Label, UL, LI, P, A, not, Br } from 'alkali'
import { DashboardStatistics } from './DashboardStatistics'
import { default as FilterPane } from '../components/filter/FilterPane'
import LoadingEllipsis from '../components/generic/LoadingEllipsis'
import { importedCollections, readonlyMode } from '../model/SearchQuery'
import './Entry.scss'
import Icon from 'components/Icon'
import * as DALogo from 'images/DA-Logo.svg'
import { SelectAnalysisType } from 'components/analysis/AnalysisSelectionHeader'
import QuestionBar from 'components/search/QuestionBar'
import AvailableQuestionsPane, { shortcutsTab } from 'components/entry/AvailableQuestionsPane'
import { hasScreeningAccess } from 'model/Screening'
import { app } from 'app/app'

let mode = reactive('Loading')

export let readonlyUser

function switchToDashboardStatistics() {
	document.body.className = 'ask-question dashboard-statistics'
	mode.put('Dashboard Statistics')
	accordion.innerHTML = ''
	accordion.append(
		LI('.build-question-container', [
			AccordionHeader('dashboard-statistics'),
			DashboardStatistics
		]),
		AvailableQuestionsPane,
		Div('.spacer')
	)
}

const sectionTitle = (section) => {
	switch(section){
		case('build-question'):
			return 'Build a Question';
		case('dashboard-statistics'):
			return 'Dashboard Statistics';
	}
}
const readonlyTabs = Div('.tabs.readonly', [
	H2('Shortcuts'),
	Div('.tab-options', [
		Button('#examples.question-tab',
			{
				content: 'Examples',
				onclick() {
					shortcutsTab.put('examples')
				},
				classes: {
					active: shortcutsTab.to((tab) => tab == 'examples'),
				},
			}
		),
	])
])

const regularTabs = Div('.tabs', {
	created(properties) {
		document.body.classList.remove('loading-page')
		properties.content = [
			H2('Shortcuts'),
			Div('.tab-options', {
				classes: {
					'no-collections': importedCollections.to(collections => !collections.length),
					'no-screening': not(hasScreeningAccess),
				}
			}, [
				Button('#recent.question-tab', {
					content: 'Recent',
					onclick() {
						shortcutsTab.put('recent')
					},
					classes: {
						active: shortcutsTab.to((tab) => tab == 'recent'),
					},
				}),
				Button('#favorites.question-tab',
					{
						content: 'Favorites',
						onclick() {
							shortcutsTab.put('favorites')
						},
						classes: {
							active: shortcutsTab.to((tab) => tab == 'favorites'),
						},
					}
				),
				Button('#collections.question-tab',
					{
						content: 'Collections',
						display: importedCollections.to(collections => collections.length > 0),
						onclick() {
							shortcutsTab.put('collections')
						},
						classes: {
							active: shortcutsTab.to((tab) => tab == 'collections'),
						},
					}
				),
				Button('#screenings.question-tab',
					{
						content: 'Screenings',
						display: hasScreeningAccess,
						onclick() {
							shortcutsTab.put('screenings')
						},
						classes: {
							active: shortcutsTab.to((tab) => tab == 'screenings'),
						},
					}
				),
				Button('#examples.question-tab',
					{
						content: 'Examples',
						onclick() {
							shortcutsTab.put('examples')
						},
						classes: {
							active: shortcutsTab.to((tab) => tab == 'examples'),
						},
					}
				),
			])
		]
	}
})
export let currentTab = localStorage.getItem('available-question-tab');

// TO DO for future code structuring, this could probably be written more cleanly/straight-forward with a simple reactive variable and declarative elements:

// let accordionOpen = reactive(false)
// ...
// content: H2({
//     classes: { active: accordionOpen },
//     ariaExpanded: accordionOpen,
//   }, [
//     Section({
//         classes: { active: accordionOpen },
//         ariaHidden: not(accordionOpen),
//         content: section,
//     }}
//   ]) 
// (and this could eliminate all the code that queries the DOM (131-134) and imperative changes the attributes and classes (115-126), all of which will require extra effort to maintain when we make any changes to the DOM/layout structure, which we will).


export const closeAccordion = (headerElement, sectionContent) => {
	headerElement.classList.remove("active");
	headerElement.setAttribute("aria-expanded", 'false');
	sectionContent.setAttribute("aria-hidden", 'true');
	sectionContent.classList.remove("active");
}

export const openAccordion = (headerElement, sectionContent) => {
	headerElement.classList.add("active");
	headerElement.setAttribute("aria-expanded", 'true');
	sectionContent.setAttribute("aria-hidden", 'false');
	sectionContent.classList.add("active");
}
export const AccordionHeader = (section) => Button(`.section-header${((section == 'build-question' || section == 'dashboard-statistics') ? `.active#${section}-header`: `#${section}-header`)}`, {
	content: [
		(section == 'shortcuts') ? (readonlyUser ? readonlyTabs : regularTabs) : H2([sectionTitle(section)])],
	onclick: (event) => {
		let headerElement = document.getElementById(`${section}-header`),
		headerClickTarget = event.target == headerElement,
		accordionOpen = headerElement?.classList?.contains("active"),
		sectionContent = headerElement?.nextElementSibling

		switch (section) {
			case 'shortcuts':
				let currentTab = localStorage.getItem('available-question-tab');
				// Check if initial state
				if (currentTab == 'null') {
					shortcutsTab.put('examples')
				}
				// We need to check if the button or section header is clicked so we can appropriately open and close the section content
				// If the accordion is open
				if ((accordionOpen && (currentTab == "null")) || (accordionOpen && headerClickTarget)) {
					closeAccordion(headerElement, sectionContent)
					shortcutsTab.put(null);
					// If the accordion is closed
				} else if (!accordionOpen) {
					openAccordion(headerElement, sectionContent)
				}
				break;
			default: 
				// We need to check if the button or section header is clicked so we can appropriately open and close the section content
				// If the accordion is open
				if (accordionOpen) {
					closeAccordion(headerElement, sectionContent)
					// If the accordion is closed
				} else if (!accordionOpen) {
					openAccordion(headerElement, sectionContent)
				}
				break;
		}
	},
	created: () => {
		readonlyUser ? localStorage.setItem('available-question-tab', 'examples') : localStorage.setItem('available-question-tab', null)
	}
})
let accordion
export const EntryContent = Div('.landing-content', [
	Div('.actions-container', [
		A({ href: '/', tabIndex: 1 }, [Icon('.entry-doc-analytics-logo', { icon: DALogo })]),
		Div('.query-container', [
			H2('.section-header', [
				'Ask a safety or efficacy question for any therapeutic intervention',
			]),
			Div('.analysis-type-container', [Label('With Analysis Type'), SelectAnalysisType()]),
			QuestionBar.with({
				buttonId: 'landing-search-button',
				id: 'landing-questionbar',
			}),
		]),
		(accordion = new UL('.accessible-accordion', [
			LI('.build-question-container', [
				AccordionHeader('build-question'),
				Div('.pico-choices.section-content.active', [new FilterPane({})]),
			]),
			AvailableQuestionsPane,
		])),
		Div('.spacer'),
	]),
	Div('.landing-footer', [
		P([
			'Our database currently contains the following ',
			reactive(app.user).to((user) =>
				user.IsInternal
					? A(
							{
								onclick() {
									switchToDashboardStatistics()
								},
							},
							['sources']
					  )
					: 'sources'
			),
			': PubMed, ClinicalTrials.gov, EU Clinicals Trial Register, COVID-19 Open Research Dataset, WHO ICTRP, Congresses',
		]),
		Br(),
		P([
			'Dr.Evidence adheres to global security and data privacy guidelines and regulations. For more information, please ',
			A(
				{
					href: 'https://label.doctorevidence.com/privacy-policy',
					target: '_blank',
				},
				['click']
			),
			' to review our information management policy.',
		]),
	]),
])

export const Entry = readonlyMode.to((readonly) => {
	if (readonly && app.user) {
		readonlyUser = true
		switchToDashboardStatistics()
	}
	return EntryContent
})
